/**
 * @file:
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-09-15 17:26:52
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-09-21 11:27:02
 * @FilePath: /console-znzs/src/vuex/index.js
 */
import createStore from './store';

const store = createStore();
export default store;